/**
 * Validation Mode Constants
 *
 * Single source of truth for all validation mode strings.
 * Use these constants instead of string literals to ensure type safety
 * and make refactoring easier.
 *
 * @example
 * ```typescript
 * import { VALIDATION_MODES } from './constants/validation-modes';
 *
 * const validation = {
 *   mode: VALIDATION_MODES.SIMPLE,
 *   answers: { x: "5" }
 * };
 * ```
 */

/**
 * Validation Modes
 *
 * These are the validation modes used in the JSON format.
 */
export const VALIDATION_MODES = {
  /** Simple answer matching validation */
  SIMPLE: 'simple',

  /** Expression-based validation using JavaScript expressions */
  EXPRESSION: 'expression',

  /** Mixed: simple per-widget answers AND a boolean expression over free variables */
  MIXED: 'mixed',
} as const;

/**
 * Type helper to get all validation mode values as a union type
 */
export type ValidationMode = typeof VALIDATION_MODES[keyof typeof VALIDATION_MODES];
